// Wishlist (localStorage-based)
(function() {
  const STORAGE_KEY = 'edit_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch { return []; }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    updateCounts();
    updateButtons();
  }

  function add(handle) {
    const list = getWishlist();
    if (!list.includes(handle)) {
      list.push(handle);
      saveWishlist(list);
    }
  }

  function remove(handle) {
    const list = getWishlist().filter(h => h !== handle);
    saveWishlist(list);
  }

  function has(handle) {
    return getWishlist().includes(handle);
  }

  function updateCounts() {
    const count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(el => {
      el.textContent = count;
    });
  }

  function updateButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
      const handle = btn.dataset.productHandle;
      if (has(handle)) {
        btn.classList.add('is-wishlisted');
        btn.setAttribute('aria-label', 'Remove from wishlist');
      } else {
        btn.classList.remove('is-wishlisted');
        btn.setAttribute('aria-label', 'Add to wishlist');
      }
    });
  }

  // Toggle handler
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    const handle = btn.dataset.productHandle;
    if (has(handle)) {
      remove(handle);
    } else {
      add(handle);
    }
  });

  // Wishlist page rendering
  async function renderWishlistPage() {
    const container = document.querySelector('[data-wishlist-grid]');
    if (!container) return;

    const list = getWishlist();
    const emptyEl = document.querySelector('[data-wishlist-empty]');

    if (list.length === 0) {
      if (emptyEl) emptyEl.hidden = false;
      container.hidden = true;
      return;
    }

    if (emptyEl) emptyEl.hidden = true;
    container.hidden = false;
    container.innerHTML = '<p class="wishlist-loading">Loading your wishlist...</p>';

    try {
      const products = await Promise.all(
        list.map(handle =>
          fetch(`/products/${handle}.json`)
            .then(r => r.ok ? r.json() : null)
            .catch(() => null)
        )
      );

      const validProducts = products.filter(p => p && p.product);

      if (validProducts.length === 0) {
        container.innerHTML = '<p>Your wishlisted products are no longer available.</p>';
        return;
      }

      container.innerHTML = validProducts.map(({ product }) => {
        const variant = product.variants[0];
        const image = product.image ? product.image.src.replace(/(\.[^.]+)$/, '_400x$1') : '';
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        const available = variant.available;

        return `
          <div class="product-card${!available ? ' product-card--sold-out' : ''}">
            <a href="/products/${product.handle}" class="product-card__image-link">
              ${image ? `<img src="${image}" alt="${product.title}" class="product-card__image" loading="lazy">` : '<div class="product-card__image product-card__image--placeholder"></div>'}
              <div class="product-card__badges">
                ${!available ? '<span class="product-card__badge product-card__badge--sold-out">Sold out</span>' : ''}
                ${onSale ? '<span class="product-card__badge product-card__badge--sale">Sale</span>' : ''}
              </div>
            </a>
            <div class="product-card__info">
              <h3 class="product-card__title"><a href="/products/${product.handle}">${product.title}</a></h3>
              <div class="product-card__price">
                ${onSale ? `<s class="product-card__price--compare">\u00a3${(variant.compare_at_price / 100).toFixed(2)}</s> <span class="product-card__price--sale">\u00a3${(variant.price / 100).toFixed(2)}</span>` : `<span>\u00a3${(variant.price / 100).toFixed(2)}</span>`}
              </div>
              <button class="btn btn--secondary product-card__add" onclick="window.Wishlist.remove('${product.handle}'); this.closest('.product-card').remove();">Remove</button>
            </div>
          </div>
        `;
      }).join('');
    } catch (err) {
      container.innerHTML = '<p>Error loading wishlist. Please try again.</p>';
    }
  }

  // Expose global API
  window.Wishlist = { add, remove, has, getAll: getWishlist };

  // Init
  updateCounts();
  updateButtons();
  renderWishlistPage();
})();
